"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setCustomConfig = exports.customBaseUrl = exports.batchingUploadTimeout = exports.batchingSizeLimit = exports.isBatchingEnabled = void 0;
var logger_1 = require("../logger");
var micro_memoize_1 = __importDefault(require("micro-memoize"));
var cof_1 = require("./cof");
var configDefaultValues = {
    isBatchingEnabled: true,
    batchingSizeLimit: 20,
    batchingUploadTimeout: 5000,
    customBaseUrl: null
};
exports.isBatchingEnabled = config("isBatchingEnabled", function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2, (0, cof_1.getCofValue)("BLIZZARD_WEB_BATCHING_ENABLED", function (v) { return v.boolValue; })];
}); }); });
exports.batchingSizeLimit = config("batchingSizeLimit", function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2, (0, cof_1.getCofValue)("BLIZZARD_WEB_BATCHING_SIZE_LIMIT", function (v) { return v.intValue; })];
}); }); });
exports.batchingUploadTimeout = config("batchingUploadTimeout", function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2, (0, cof_1.getCofValue)("BLIZZARD_WEB_BATCHING_UPLOAD_TIMEOUT", function (v) { return v.intValue; })];
}); }); });
exports.customBaseUrl = config("customBaseUrl", function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2, undefined];
}); }); });
var customConfig = {};
function setCustomConfig(config) {
    customConfig = config;
}
exports.setCustomConfig = setCustomConfig;
function config(name, fn) {
    var _this = this;
    return (0, micro_memoize_1["default"])(function () { return __awaiter(_this, void 0, void 0, function () {
        var custom, v, d;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    custom = customConfig[name];
                    if (custom !== undefined) {
                        log.info("[Config override] ".concat(name, "="), custom);
                        return [2, custom];
                    }
                    return [4, fn()];
                case 1:
                    v = _a.sent();
                    if (v !== undefined) {
                        log.info("[Config loaded] ".concat(name, "="), v);
                        return [2, v];
                    }
                    d = configDefaultValues[name];
                    log.info("[Config default] ".concat(name, "="), d);
                    return [2, d];
            }
        });
    }); });
}
var log = (0, logger_1.getLogger)("config");
//# sourceMappingURL=index.js.map